<template>
  <section class="section featured-venues latest-news">
    <div class="container">
      <div class="section-heading">
        <h2><span>Tin tức</span> mới nhất</h2>
        <p class="sub-title">
          Cập nhật những tin tức mới nhất từ thế giới cầu lông – luôn nắm bắt thông tin
           và truyền cảm hứng từ những thành tích ấn tượng và khoảnh khắc đầy kịch tính trong môn thể thao này.
        </p>
      </div>
      <div class="row">
        <div class="featured-slider-group">
          <div class="owl-carousel featured-venues-slider owl-theme">
            <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
              <Slide v-for="record in News" :key="record.id">
                <!-- News -->
                <div class="featured-venues-item text-start">
                  <div class="listing-item mb-0">
                    <div class="listing-img">
                      <router-link to="/tin-tuc/tieu-de">
                        <img
                          :src="require(`@/assets/img/venues/${record.Images}`)"
                          class="img-fluid"
                          alt="Venues"
                        />
                      </router-link>
                      <div class="fav-item-venues news-sports">
                        <span class="tag tag-blue">{{ record.Sports }}</span>
                        <div class="list-reviews coche-star">
                          <a
                            href="javascript:void(0)"
                            class="fav-icon"
                            @click="toggleSelected(item)"
                          >
                            <i class="feather-heart"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="listing-content news-content">
                      <div class="listing-venue-owner">
                        <div class="navigation">
                          <img
                            :src="require(`@/assets/img/profiles/${record.User}`)"
                            class="img-fluid"
                            alt="User"
                          />{{ record.Name }}
                          <span><i class="feather-calendar"></i>{{ record.Date }}</span>
                        </div>
                      </div>
                      <h3 class="listing-title">
                        <a href="tin-tuc/tieu-de">{{ record.Title }}</a>
                      </h3>
                      <div class="listing-button read-new">
                        <ul class="nav">
                          <li><i class="feather-heart"></i>{{ record.Like }}</li>
                          <li>
                            <i class="feather-message-square"></i>{{ record.Comment }}
                          </li>
                        </ul>
                        <span
                          ><img
                            :src="require(`@/assets/img/icons/${record.Clock}`)"
                            class="img-fluid"
                            alt="Icon"
                          />{{ record.LastSeen }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /News -->
              </Slide>
              <template #addons>
                <Navigation />
              </template>
            </Carousel>
          </div>
        </div>
      </div>

      <!-- View More -->
      <div class="view-all text-center">
        <router-link to="/tin-tuc" class="btn btn-secondary btn-icon"
          >Xem thêm<i class="feather-arrow-right-circle ms-2"></i
        ></router-link>
      </div>
      <!-- View More -->
    </div>
  </section>
</template>
<script>
import { Carousel, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import News from "@/assets/json/news.json";
export default {
  data() {
    return {
      News: News,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        991: {
          itemsToShow: 2,
          snapAlign: "start",
        },
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  methods: {
    toggleSelected(item) {
      item.isSelected = !item.isSelected;
    },
  },
};
</script>
